// import { viewPorts } from '@/constants/viewPorts'

export const FORWARDS_CALL_TO_HEADERS_TABLE = [
    {
        name: 'Priority',
        value: 'priority',
        disabled: true,
        minWidth: 50,
    },
    {
        name: 'Weight',
        value: 'weight',
        disabled: true,
        minWidth: 50,
    },
    {
        name: 'Name',
        value: 'name',
        disabled: true,
        grow: true,
        minWidth: 100,
    },
    {
        name: 'Number',
        value: 'destination',
    },
    {
        name: 'Buyer',
        value: 'buyer',
        minWidth: 80,
        activeDefault: false,
    },
    {
        name: 'Type',
        value: 'type',
        minWidth: 60,
        grow: true,
    },
    {
        name: 'Revenue',
        value: 'revenue',
        minWidth: 60,
    },
    {
        name: 'Status',
        value: 'status',
        align: 'center',
        minWidth: 80,
    },
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 74,
        align: 'center',
        disabled: true,
        // sticky: true,
        // right: viewPorts.mb >= window.innerWidth ? -1 : 0,
    },
]
